import { Injectable } from '@angular/core';
import { BaseApiService } from '../../base-service/base-api.service';
import { OmegaVehicleDetails } from '../../models/omega/omega-vehicle-details';
import { OmegaCustomerDetails } from '../../models/omega/omega-customer-details';

@Injectable()
export class OmegaService extends BaseApiService {

    public getVehicleOmegaDetails(vehicleId) {
        return this.get('Foundation/Omega/Vehicle/' + vehicleId + '/Details');
    }

    public updateVehicleOmegaDetails(details: OmegaVehicleDetails) {
        return this.post('Foundation/Omega/Vehicle/Details', details);
    }

    public getCustomerOmegaDetails(customerNumberId) {
        return this.get('Foundation/Omega/Customer/' + customerNumberId + '/Details');
    }

    public updateCustomerOmegaDetails(details: OmegaCustomerDetails) {
        return this.post('Foundation/Omega/Customer/Details', details);
    }
}
